var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204 0c56 0 106 22 142 60 38 36 60 88 60 144s-22 106-60 142c-36 38-86 60-142 60S96 384 60 346C22 310 0 260 0 204S22 96 60 60C96 22 148 0 204 0zm74 298c-16-10-26-14-30-16-2-2-4-2-4-4-2-2-2-4-2-6v-32c2-2 4-6 6-8 0-4 2-8 2-10v-6l6-2c2 0 0 0 0 0 2-2 4-6 6-14 2-6 2-10 2-14h-10c2-4 2-8 4-14 8-46-12-46-12-46l-4-2-2-2s-2-8-12-12l-12-6c-35-6-67 17-70 44v12c0 4 0 8 2 12l2 14h-8v2c0 4 0 8 2 12 2 8 4 12 6 14h-2l6 2 2 6c0 2 0 6 2 8 2 4 2 8 4 10l2 2v30c0 2-2 4-2 6l-4 4c-4 0-16 6-30 16-16 8-34 20-52 36l-4 4c2 2 4 2 4 4 34 30 78 48 128 48 48 0 93-17 127-49l2-2c-11-11-41-33-55-41zM62 326c2-2 2-4 4-4 20-16 38-28 54-38 12-8 22-12 28-16v-22c-2-2-4-6-4-10-2-2-2-6-2-8l-6-6c-2-4-4-8-8-18 0-6-2-10-2-14 0-6 2-10 2-12l4-4c-2-4-2-10-2-14 0-6 0-10 2-16 8-39 47-64 88-54 6 0 10 4 16 6 8 4 14 12 16 14 8 4 28 16 22 64 2 2 2 4 4 6 2 6 2 14-2 24-2 10-4 14-6 18l-6 6c0 2-2 6-2 8-2 4-4 8-4 10v22c4 4 16 10 28 16 16 10 34 22 52 38l6 6c30-34 46-78 46-124 0-52-20-100-54-134s-80-54-132-54S104 36 70 70s-54 82-54 134c0 46 16 90 46 122z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.ba9b283d90c9fbb2048f500ea25884a1.svg";
export { ForwardRef as ReactComponent };